import { render, staticRenderFns } from "./wenzhangfenlei.vue?vue&type=template&id=7f08b0e9&"
import script from "./wenzhangfenlei.vue?vue&type=script&lang=js&"
export * from "./wenzhangfenlei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports